import { render, staticRenderFns } from "./WidgetAgenciesResume.vue?vue&type=template&id=8d5d8686"
import script from "./WidgetAgenciesResume.vue?vue&type=script&lang=js"
export * from "./WidgetAgenciesResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports